import React, { useState } from "react";
import "./registrationfrom.css";
import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
import EditIcon from "../../Assets/Images/EployeeRegistration/edit_icon.png";

function CustomFields({ setCustomFields }) {
  const [isOpen, setIsOpen] = useState(false);
  const [values, setValues] = useState({
    custom_field_1: "",
    custom_field_2: "",
    custom_field_3: "",
    custom_field_4: "",
    custom_field_5: "",
    custom_field_6: "",
  });

  const onChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
    // setCustomFields((prevInfo) => ({
    //   ...prevInfo,
    //   [name]: value,
    // }));
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="personal-info">
      <div className="personal-header">
        <div className="header">
          <h2>CUSTOM FIELDS</h2>
          <img src={EditIcon} alt="icon"/>
        </div>
        <div className="accordion-btn" onClick={toggleAccordion}>
          {isOpen ? (
            <div className="minus"></div>
          ) : (
            <div className="plus">+</div>
          )}
        </div>
      </div>
      <div>
        {isOpen && (
          <div className="accordion-content">
            <div className="grid-container">
              <div className="grid-item">
                <FormInputs
                  label="Custom Field 1"
                  type="text"
                  name="custom_field_1"
                  value={values.custom_field_1}
                  onChange={onChange}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Custom Field 2"
                  type="text"
                  name="custom_field_2"
                  value={values.custom_field_2}
                  onChange={onChange}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Custom Field 3"
                  type="text"
                  name="custom_field_3"
                  value={values.custom_field_3}
                  onChange={onChange}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Custom Field 4"
                  type="text"
                  name="custom_field_4"
                  value={values.custom_field_4}
                  onChange={onChange}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Custom Field 5"
                  type="text"
                  name="custom_field_5"
                  value={values.custom_field_5}
                  onChange={onChange}
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Custom Field 6"
                  type="text"
                  name="custom_field_6"
                  value={values.custom_field_6}
                  onChange={onChange}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CustomFields;
